import { Capacitor } from '@capacitor/core';

const DEFAULT_NATIVE_API_BASE = 'https://api.lovevibesmusic.com/api';

export const getApiBaseUrl = () => {
  const envBase = process.env.REACT_APP_API_BASE_URL;
  if (envBase && envBase.trim()) {
    return envBase.trim();
  }

  if (Capacitor?.isNativePlatform?.()) {
    return DEFAULT_NATIVE_API_BASE;
  }

  return '/api';
};

